module.exports = __webpack_public_path__ + "static/blog-post-1.2-d8d5c6cd16c1cfd3b43450d05c4e28eb.png";